<header raHeader></header>
<main class="flex-1 relative grid">
  <router-outlet class="absolute" />
</main>
<footer raFooter></footer>
